import React, { useState } from "react";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { Link } from "react-router-dom";
import AllLeads from './LeadsTabs/AllLeads'
import PendingLeads from './LeadsTabs/PendingLeads'
import FirstFollowUpLeads from './LeadsTabs/FirstFollowUpLeads'
import SecondFollowUpLeads from './LeadsTabs/SecondFollowUpLeads'
import FinalFollowUpLeads from './LeadsTabs/FinalFollowUpLeads'
import ProcessedLeads from "./LeadsTabs/ProcessedLeads";
import NotQualifiedLeads from "./LeadsTabs/NotQualifiedLeads";
import RejectedLeads from "./LeadsTabs/RejectedLeads";
import ConvertedLeads from "./LeadsTabs/ConvertedLeads";
import PipelineLeads from "./LeadsTabs/PipelineLeads";
import IsAllowed from "../../Utils/IsAllowed";


import './Leads.css';
function Leads(props) {
  const [allcount, setAllCount] = useState(0);
  const [pendingcount, setPendingCount] = useState(0);
  const [processedcount, setProcessedCount] = useState(0);
  const [convertedcount, setConvertedCount] = useState(0);
  const [rejectedcount, setRejectedCount] = useState(0);
  const [pipelinecount, setPipelineCount] = useState(0);
  const [firstFollowUpcount, setFirstFollowUpCount] = useState(0);
  const [secondFollowUpcount, setSecondFollowUpCount] = useState(0);
  const [finalfollowupcount, setFinalFollowUpCount] = useState(0);
  const [notqualifiedcount, setNotQualifiedCount] = useState(0);
  const [tabIndex, setTabIndex] = useState(props && props.location && props.location.tab ? props.location.tab : 0);
  // const [inactivecount, setInactivecount] = useState(0);
  // const [outofstockcount, setOutofstockcount] = useState(0);
  // const [draftcount, setDraftcount] = useState(0);
  // const [lockedcount, setLockedcount] = useState(0);


  return (
    <div>
      <div className="col-md-12 text-right">
        {IsAllowed(["10102"]) && (
          <Link className="btn btn-primary " to="/add-leads">
            ADD LEAD
          </Link>
        )}
      </div>
      <Tabs selectedIndex={tabIndex} onSelect={index => setTabIndex(index)}>
        <TabList>
          <Tab>All <span class="badge badge-primary badge-counter">{allcount}</span></Tab>
          <Tab>Pending <span class="badge badge-warning badge-counter">{pendingcount}</span></Tab>
          <Tab>Processed <span class="badge badge-primary badge-counter">{processedcount}</span></Tab>
          <Tab>First Follow Up <span class="badge badge-info badge-counter">{firstFollowUpcount}</span></Tab>
          <Tab>Second Follow Up <span class="badge badge-light badge-counter">{secondFollowUpcount}</span></Tab>
          <Tab>Final Follow Up <span class="badge badge-info badge-counter">{finalfollowupcount}</span></Tab>
          <Tab>Converted <span class="badge badge-success badge-counter">{convertedcount}</span></Tab>
          <Tab>Rejected <span class="badge badge-danger badge-counter">{rejectedcount}</span></Tab>
          <Tab>Pipeline <span class="badge badge-light badge-counter">{pipelinecount}</span></Tab>
          <Tab>Not Qualified <span class="badge badge-info badge-counter">{notqualifiedcount}</span></Tab>

        </TabList>


        <TabPanel>
          <AllLeads setAllCount={setAllCount}></AllLeads>
        </TabPanel>
        <TabPanel>
          <PendingLeads setPendingCount={setPendingCount}></PendingLeads>
        </TabPanel>
        <TabPanel>
          <ProcessedLeads setProcessedCount={setProcessedCount}></ProcessedLeads>
        </TabPanel>
        <TabPanel>
          <FirstFollowUpLeads setFirstFollowUpCount={setFirstFollowUpCount}></FirstFollowUpLeads>
        </TabPanel>
         <TabPanel>
          <SecondFollowUpLeads setSecondFollowUpCount={setSecondFollowUpCount}></SecondFollowUpLeads>
        </TabPanel>
         <TabPanel>
          <FinalFollowUpLeads setFinalFollowUpCount={setFinalFollowUpCount}></FinalFollowUpLeads>
        </TabPanel>
        <TabPanel>
          <ConvertedLeads setConvertedCount={setConvertedCount}></ConvertedLeads>
        </TabPanel>
        <TabPanel>
          <RejectedLeads setRejectedCount={setRejectedCount}></RejectedLeads>
        </TabPanel>
        <TabPanel>
          <PipelineLeads setPipelineCount={setPipelineCount}></PipelineLeads>
        </TabPanel>
         <TabPanel>
          <NotQualifiedLeads setNotQualifiedCount={setNotQualifiedCount}></NotQualifiedLeads>
        </TabPanel>
      </Tabs>
    </div>
  );
}

export default Leads;
